// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mention-item{padding:4px 10px;border-radius:4px}.mention-selected{background:#dee0e2}.loading-snippet{padding:4px 10px;border-radius:4px}", ""]);
// Exports
module.exports = exports;
